var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//This will prevent background scroll when drawer is open in mobile
function BindLockUnlock(){
  let drawer = document.querySelector("div#cart-drawer-heading");
  let mobileCartDrawerButton = document.querySelector("header.site-header .site-header-right .site-header-cart .site-header-cart--button");
  if(drawer && mobileCartDrawerButton){
    let mobileCartDrawerCloseButton = drawer.nextElementSibling;
    let html = document.getElementsByTagName("html")[0];
    let observer = new MutationObserver(function(){
      setTimeout(function(){
        let drawerClosed = document.querySelector("div[x-show='open'][style]");
        if(drawerClosed){
          html.classList.remove("scroll-locked");
        }else{
          html.classList.add("scroll-locked");
        }
      },300);
    });
  
    observer.observe(document.querySelector("html"),{childList:true,attributes:true});
    return;
  }
  setTimeout(BindLockUnlock,10);
}
if(window.innerWidth<640){
    BindLockUnlock();
}

/* FAQ Section PDP */

function openAskFaqSection(element) {
  const faqItem = element.parentElement;
  const svgIcon = element.querySelector('svg');
  const ask = element.querySelector('span');
  const isOpen = faqItem.getAttribute("open") === "true";

  if (isOpen) {
    svgIcon.style.transform = 'rotate(0deg)';
    faqItem.style.height = '65px';
    faqItem.setAttribute("open", "false");
    ask.style.fontWeight = '500';
  } else {
    svgIcon.style.transform = 'rotate(180deg)';
    faqItem.style.height = faqItem.scrollHeight + 'px';
    faqItem.setAttribute("open", "true");
    ask.style.fontWeight = '600';
  }
}